export default __webpack_public_path__ + "basketball-pre.png";